import protobuf from 'protobufjs';
import axios from 'axios'
import { Notification } from 'element-ui'
import { getAccessToken, removeAccessToken, removeRefreshToken, getRefreshToken, setAccessToken, setRefreshToken, } from '@/util/auth'
import { enums, framework, passport } from '@/proto/payload';
import { refreshToken } from '@/api/login'

const ErrorNo = enums.ErrorNo;
// request拦截器
const service = axios.create({
  baseURL: '/api', // /api
  timeout: 20000,
  withCredentials: false,
})

// request拦截器
service.interceptors.request.use(
  config => {
    console.log(config.data);
    console.log(getAccessToken());
    if (getAccessToken()) {
      config.headers['Authorization'] = getAccessToken();
    }
    config.headers['Content-Type'] = 'application/json'
    return config
  },
  error => {
    console.log(error)
    Promise.reject(error)
  }
)

// response 拦截器
service.interceptors.response.use(
  response => {
    const data = response.data;
    console.log(response, 9898989);
    if (data.code !== 0) {
      const { code, msg } = data;
      console.log(`errorNo = ${code}, msg = ${msg}`);
      if (code === 0) {
        Notification.success({
          message: '成功',
          duration: 3000
        });
        return
      }
      if (code === 404) {
        Notification.error({
          message: 'No account information',
          duration: 3000
        });
        return
      }
      if (code === 850) {
        Notification.error({
          message: 'Product does not exist',
          duration: 3000
        });
        return Promise.reject(code)
      }
      if (code === 801 || code === 804) {
        Notification.error({
          title: '登入狀態過期，請重新登入',
          duration: 5000
        })
        removeAccessToken();
        removeRefreshToken();
        removeUserInfo();
        setTimeout(() => {
          location.reload();
        }, 1000)
        return
      }
      return Promise.reject(code)
    }
    return data
  },
  error => {
    console.log(error)
    if (error.toString().indexOf('Error: timeout') !== -1) {
      console.log('超时？');
      Notification.error({
        title: '網絡請求超時',
        duration: 5000
      })

      return Promise.reject(error)
    }
    return Promise.reject(error)
  }
)

export default service
